import React, { useEffect, useRef, useState } from "react";
import {
    Button,
    Table,
    Overlay,
    Popover,
    Col,
    Form,
    Row,
} from "react-bootstrap";
import Loader from "../../../Loader/Loader";
import downloadIcon from "../../../../Assets/Images/Operation/downloadIcon.svg";
import { commonService } from "../../../../utils/commonService";
import { apiCall } from "../../../../utils/axiosService";
import { API_URL } from "../../../../utils/apiRoutes";
import { apiResponse } from "../../../../utils/apiResponse";
import moment from "moment";
import { compName } from "../../../../utils/constant";
import WidgetDetailModal from "../../WidgetDetailModal";
import { useSelector } from "react-redux";
import infoIcon from "../../../../Assets/Images/Action Icons/infoIcon..svg";
import { useParams } from "react-router-dom";
import Comments from "../Comments/Comment";
import DatePicker from "react-datepicker";
import avgOfRevPar from "../../../../Assets/Images/Glance Dashboard/Avg of RevPAR.svg";
import avgOfAdr from "../../../../Assets/Images/Glance Dashboard/Avg of ADR.svg";
import sumOfTotalRev from "../../../../Assets/Images/Glance Dashboard/Sum of Total Revenue.svg";
import overallCompAvg from "../../../../Assets/Images/Glance Dashboard/Overall Comp Avg.svg";
import viewIcon from "../../../../Assets/Images/Action Icons/viewaction.svg";
import cancellationPercentage from "../../../../Assets/Images/Glance Dashboard/Cancellation Percentage.svg";
import avgOfLeadTime from "../../../../Assets/Images/Glance Dashboard/Avg of Lead Time.svg";
import avgOfLengthOfStay from "../../../../Assets/Images/Glance Dashboard/Avg Length of Stay.svg";
import totalInventory from "../../../../Assets/Images/Glance Dashboard/Total Inventory.svg";
import avgOfRoomAvailable from "../../../../Assets/Images/Glance Dashboard/Avg of Rooms Available.svg";
import avgOfRoomSold from "../../../../Assets/Images/Glance Dashboard/Avg of Room Sold.svg";
import downArrowForDrilldown from "../../../../Assets/Images/Header/downArrow.svg";
import emailIcon from "../../../../Assets/Images/Email.svg";
import Skeleton from "../../../Skeletons/Skeleton";

export const PropertyOverview = ({
    setCompDataFromChild,
    rowIndex,
    colIndex,
    api,
    para,
    setting,
}) => {
    const { snapshottitle, propertyCode, snapshotId } = useParams();

    const propertyDetailFromRTK = useSelector(
        (store) => store.headerProperty.propertyDetail
    );

    const defaultAsOfDateFromRTK = useSelector(
        (store) => store.headerProperty.defaultAsOfDate
    );

    const [tblids, settblids] = useState({
        id1: commonService.GenerateGUID(),
        id2: commonService.GenerateGUID(),
        id3: commonService.GenerateGUID(),
    });

    const widgetDetailRef = useRef();

    const [widgetModal, setWidgetModal] = useState(false);

    const closeWidgetModal = () => {
        setWidgetModal(false);
    };
    const [dashboardLoading, setDashboardLoading] = useState(false);
    const [marketSegmentLoading, setMarketSegmentLoading] = useState(false);
    const [marketSegmentData, setMarketSegmentData] = useState(null);
    const clickedEyeIcon = useRef(false);
    const dateForDash = new Date();
    const [dashboardData, setDashboardData] = useState(null);
    const allDashboardDataRef = useRef();
    const [expandedRows, setExpandedRows] = useState([]);
    const startDateForDash = new Date(
        dateForDash.getFullYear(),
        dateForDash.getMonth(),
        1
    );

    const endDateForDash = new Date(
        dateForDash.getFullYear(),
        dateForDash.getMonth() + 1,
        0
    );
    const [startDateForDashboard, setStartDateForDashboard] = useState(
        defaultAsOfDateFromRTK ? new Date(defaultAsOfDateFromRTK) : ""
    );
    const [endDateForDashboard, setEndDateForDashboard] = useState(
        defaultAsOfDateFromRTK ? new Date(defaultAsOfDateFromRTK) : ""
    );
    const asOfDateFromRTK = useSelector((store) => store.headerProperty.asOfDate);
    const calledMarketSegmentRef = useRef([]);
    const [apiLoading, setApiLoading] = useState();

    const [SelectedRangePropertyOverview, setSelectedRangePropertyOverview] =
        useState("Day");
    const [groupModal, setGroupModal] = useState({
        IsDisplay: false,
        Target: null,
        Position: "top",
    });
    const closeGroupDate = () => {
        clickedEyeIcon.current = false;
        setGroupModal({
            IsDisplay: false,
            Target: null,
            Position: "bottom",
        });
    };
    const handleGroupBtnClick = (event) => {
        let Position = "bottom";
        let Top = event.nativeEvent.layerY - 2;
        if (Top + 400 > window.innerHeight) {
            Position = "top";
        }
        setGroupModal({
            IsDisplay: true,
            Target: event.target,
            Position: Position,
        });
    };
    useEffect(() => {
        setStartDateForDashboard(
            defaultAsOfDateFromRTK ? new Date(defaultAsOfDateFromRTK) : ""
        );
        setEndDateForDashboard(
            defaultAsOfDateFromRTK ? new Date(defaultAsOfDateFromRTK) : ""
        );
    }, [defaultAsOfDateFromRTK]);

    const handleDateChange = (event) => {
        const [start, end] = event;
        setStartDateForDashboard(start);
        setEndDateForDashboard(end);
        setSelectedRangePropertyOverview("");
    };

    const getRatecodeDrilldown = async (marketSegment) => {
        let segmentDrilldownResponse = await apiCall(
            {
                method: "POST",
                url:
                    API_URL.BASE_API_URL.SnapShot +
                    API_URL.REVENUE_GLANCE.TOP_RATECODE_DRILLDOWN,
                body: {
                    propertyCode: propertyCode,
                    AsOfDate: asOfDateFromRTK ? asOfDateFromRTK : "",
                    startDate: startDateForDashboard
                        ? commonService.getDateForNode(startDateForDashboard)
                        : "",
                    endDate: endDateForDashboard
                        ? commonService.getDateForNode(endDateForDashboard)
                        : "",
                    MarketSegment: marketSegment,
                },
            },
            false
        );

        let response = apiResponse(false, segmentDrilldownResponse);

        if (response?.isValidate) {
            let dataFromApi = response?.data?.data;
            let firstIndex = commonService.GenerateGUID();
            let ratecodeUpdatedData = dataFromApi?.map((item, index) => {
                if (index === 0) {
                    item.id = firstIndex;
                } else {
                    item.id = commonService.GenerateGUID();
                }
                item.name = item?.RateCode;
                item.lastLevel = true;
                item.class = "rateCodeRow";
                return item;
            });
            let updatedData = marketSegmentData?.map((item) => {
                if (item.name === marketSegment) {
                    item.children = ratecodeUpdatedData;
                }
                return item;
            });
            calledMarketSegmentRef.current = [
                ...calledMarketSegmentRef.current,
                marketSegment,
            ];
            setMarketSegmentData(updatedData);
            setExpandedRows((prev) => [...prev, firstIndex]);
            setApiLoading("");
        }

        if (!response?.isValidate) {
            calledMarketSegmentRef.current = [
                ...calledMarketSegmentRef.current,
                marketSegment,
            ];
            setApiLoading("");
        }
    };

    const toggleRows = (id) => {
        let findRows = expandedRows?.includes(id);
        if (findRows) {
            let updatedData = expandedRows?.filter((x) => x !== id);
            setExpandedRows(updatedData);
        } else {
            setExpandedRows((prev) => [...prev, id]);
        }
    };

    useEffect(() => {
        if (api !== 0) {
            if (startDateForDashboard && endDateForDashboard && asOfDateFromRTK) {
                getDashboardDetail();
                getMarketSegmentDrilldownData();
            }
        }
    }, [startDateForDashboard, endDateForDashboard, asOfDateFromRTK]);

    const getMarketSegmentDrilldownData = async () => {
        setMarketSegmentLoading(true);
        let segmentDrilldownResponse = await apiCall(
            {
                method: "POST",
                url:
                    API_URL.BASE_API_URL.SnapShot +
                    API_URL.REVENUE_GLANCE.TOP_10_MARKET_SEGMENT_DRILLDOWN,
                body: {
                    propertyCode: propertyCode,
                    AsOfDate: asOfDateFromRTK ? asOfDateFromRTK : "",
                    startDate: startDateForDashboard
                        ? commonService.getDateForNode(startDateForDashboard)
                        : "",
                    endDate: endDateForDashboard
                        ? commonService.getDateForNode(endDateForDashboard)
                        : "",
                },
            },
            false
        );

        let response = apiResponse(false, segmentDrilldownResponse);

        if (response?.isValidate) {
            let dataFromApi = response?.data?.data;
            let updatedData = dataFromApi?.map((item) => {
                item.name = item?.MarketSegment;
                item.id = commonService.GenerateGUID();
                item.lastLevel = false;
                return item;
            });
            setMarketSegmentData(updatedData);
            setMarketSegmentLoading(false);
        }

        if (!response?.isValidate) {
            setMarketSegmentData(null);
            setMarketSegmentLoading(false);
        }
    };

    const getDashboardDetail = async () => {
        setDashboardLoading(true);
        let dashboardResponse = await apiCall(
            {
                method: "POST",
                url: API_URL.BASE_API_URL.SnapShot + API_URL.REVENUE_GLANCE.DASHBOARD,
                body: {
                    propertyCode: propertyCode,
                    AsOfDate: asOfDateFromRTK ? asOfDateFromRTK : "",
                    startDate: startDateForDashboard
                        ? commonService.getDateForNode(startDateForDashboard)
                        : "",
                    endDate: endDateForDashboard
                        ? commonService.getDateForNode(endDateForDashboard)
                        : "",
                },
            },
            false
        );

        let response = apiResponse(false, dashboardResponse);

        if (response?.isValidate) {
            setDashboardData(response?.data?.data);
            setDashboardLoading(false);
        }

        if (!response?.isValidate) {
            setDashboardData(null);
            setDashboardLoading(false);
        }
    };

    const ExpandableRows = ({
        item,
        level,
        expandedRows,
        toggleRows,
        ratecodeApi,
        setApiLoading,
        apiLoading,
        calledMs,
    }) => {
        const isExpanded = expandedRows.includes(item.id);
        let isApiCalledForMs = calledMs?.filter((x) => x === item?.name);
        return (
            <>
                <tr className={`shadowOnHover ${item?.class ? item?.class : ""}`}>
                    <td className="border_right">
                        <div id={commonService.generateGlobalClickTrackerID("PropertyOverview", "div-onclick", item)}
                            className={`d-flex gap-2`}
                            style={{ marginLeft: `${level * 10}px` }}
                            onClick={() => {
                                if (!item?.lastLevel) {
                                    if (isApiCalledForMs?.length <= 0) {
                                        ratecodeApi(item?.name);
                                        setApiLoading(item?.name);
                                    }
                                    toggleRows(item.id);
                                }
                            }}
                        >
                            <p>
                                {item?.name +
                                    (item?.RateCodeDescript
                                        ? " - " + item?.RateCodeDescript
                                        : "")}
                            </p>
                            {!item?.lastLevel && <img src={downArrowForDrilldown} />}
                            {apiLoading === item?.name && (
                                <div
                                    class="spinner-border text-primary ms-2"
                                    role="status"
                                    style={{
                                        height: "13px",
                                        width: "13px",
                                        color: "#3565FC",
                                    }}
                                >
                                    <span class="sr-only"></span>
                                </div>
                            )}
                        </div>
                    </td>
                    <td className="border_right text-center">
                        {item?.Rooms
                            ? commonService.formateRoom(item?.Rooms)
                            : commonService.formateRoom(0)}
                    </td>
                    <td className="border_right text-end">
                        {item?.Revenue
                            ? commonService.formateAmount(Math.round(item?.Revenue))
                            : commonService.formateAmount(0)}
                    </td>
                    <td className="text-end">
                        {item?.ADR
                            ? commonService.formateAmount(Math.round(item?.ADR))
                            : commonService.formateAmount(0)}
                    </td>
                </tr>
                {isExpanded &&
                    item.children &&
                    item.children.map((child) => (
                        <ExpandableRows
                            key={child.id}
                            item={child}
                            level={level + 1}
                            expandedRows={expandedRows}
                            toggleRows={toggleRows}
                        />
                    ))}
            </>
        );
    };

    return (
        <div className="widget-container" style={{ position: "relative" }}>
            {api !== 0 && (
                <div className="gap-1 widget-container-menu">
                    <Button className="heading-menu-btns" type="button" title="Send Mail">
                        <img id={commonService.generateGlobalClickTrackerID("PropertyOverview", "emailicon", propertyCode)}
                            src={emailIcon}
                            alt="emailIcon"
                            onClick={() => {
                                commonService.fnSendWidgetMail(
                                    tblids.id1 + "," + tblids.id2 + "," + tblids.id3,
                                    "Property 360",
                                    snapshotId,
                                    defaultAsOfDateFromRTK,
                                    "",
                                    para?.widgetId
                                );
                            }}
                        />
                    </Button>
                    <Button className="heading-menu-btns" type="button">
                        <img id={commonService.generateGlobalClickTrackerID("PropertyOverview", "info", propertyCode)}
                            src={infoIcon}
                            alt="info"
                            onClick={() => {
                                widgetDetailRef.current = {
                                    widgetdetails: "",
                                    usernote: "",
                                    compName: compName?.PropertyOverview,
                                    widgetId: para?.widgetId,
                                };
                                setWidgetModal(true);
                            }}
                        />
                    </Button>
                    <Button className="heading-menu-btns" type="button">
                        <img id={commonService.generateGlobalClickTrackerID("PropertyOverview", "menuicon", propertyCode)}
                            src={downloadIcon}
                            alt="menuIcon"
                            import={tblids.id1 + "," + tblids.id2 + "," + tblids.id3}
                            onClick={() =>
                                commonService.fnExportInCSV(
                                    tblids.id1 + "," + tblids.id2 + "," + tblids.id3,
                                    // "Day By Day Channel"
                                    `${para?.propertyCode}-Property 360-${moment(
                                        new Date()
                                    ).format("MMDDYYYY")}`
                                )
                            }
                        />
                    </Button>
                </div>
            )}
            <table>
                <tr>
                    <div className="d-flex gap-2 justify-content-end crm-dashboard-bot-top">
                        <div className="width175">
                            <DatePicker id={commonService.generateGlobalClickTrackerID("PropertyOverview", "datepicker-onchange", propertyCode)}
                                portalId="datepicker-root"
                                onChange={(event) => handleDateChange(event)}
                                startDate={startDateForDashboard ? startDateForDashboard : ""}
                                endDate={endDateForDashboard ? endDateForDashboard : ""}
                                selectsRange
                                monthsShown={2}
                            />
                        </div>
                        <div className="form-groups form-groups-radio-btn">
                            <div className="form-groups-radio">
                                <div className="form-radio">
                                    <input
                                        type="radio"
                                        className="form-check-input"
                                        name="SelectedRangePropertyOverview"
                                        value="daily"
                                        id="daily_1"
                                        checked={
                                            SelectedRangePropertyOverview === "Day" ? true : false
                                        }
                                        onClick={() => {
                                            setSelectedRangePropertyOverview("Day");
                                            setStartDateForDashboard(
                                                defaultAsOfDateFromRTK
                                                    ? new Date(defaultAsOfDateFromRTK)
                                                    : ""
                                            );
                                            setEndDateForDashboard(
                                                defaultAsOfDateFromRTK
                                                    ? new Date(defaultAsOfDateFromRTK)
                                                    : ""
                                            );
                                        }}
                                    />
                                    <Form.Check.Label htmlFor="daily_1" className="label-radio">
                                        Current Day
                                    </Form.Check.Label>
                                </div>
                                <div className="form-radio">
                                    <input
                                        type="radio"
                                        className="form-check-input"
                                        name="SelectedRangePropertyOverview"
                                        value="weekly"
                                        id="weekly_1"
                                        checked={
                                            SelectedRangePropertyOverview === "Week" ? true : false
                                        }
                                        onClick={() => {
                                            setSelectedRangePropertyOverview("Week");
                                            const today = new Date();
                                            const dayOfWeek = today.getDay();
                                            const startOfWeek = new Date(today);
                                            startOfWeek.setDate(today.getDate() - dayOfWeek);
                                            const endOfWeek = new Date(today);
                                            endOfWeek.setDate(today.getDate() + (6 - dayOfWeek));
                                            setStartDateForDashboard(startOfWeek);
                                            setEndDateForDashboard(endOfWeek);
                                        }}
                                    />
                                    <Form.Check.Label htmlFor="weekly_1" className="label-radio">
                                        Current Week
                                    </Form.Check.Label>
                                </div>
                                <div className="form-radio">
                                    <input
                                        type="radio"
                                        className="form-check-input"
                                        name="SelectedRangePropertyOverview"
                                        value="monthly"
                                        id="monthly_1"
                                        checked={
                                            SelectedRangePropertyOverview === "Month" ? true : false
                                        }
                                        onClick={() => {
                                            setSelectedRangePropertyOverview("Month");
                                            setStartDateForDashboard(startDateForDash);
                                            setEndDateForDashboard(endDateForDash);
                                        }}
                                    />
                                    <Form.Check.Label htmlFor="monthly_1" className="label-radio">
                                        Current Month
                                    </Form.Check.Label>
                                </div>
                                <div className="form-radio">
                                    <input
                                        type="radio"
                                        className="form-check-input"
                                        name="SelectedRangePropertyOverview"
                                        value="yearly"
                                        id="yearly_1"
                                        checked={
                                            SelectedRangePropertyOverview === "Year" ? true : false
                                        }
                                        onClick={() => {
                                            setSelectedRangePropertyOverview("Year");
                                            setStartDateForDashboard(
                                                new Date(new Date().getFullYear(), 0, 1)
                                            );
                                            setEndDateForDashboard(
                                                new Date(new Date().getFullYear(), 11, 31)
                                            );
                                        }}
                                    />
                                    <Form.Check.Label htmlFor="yearly_1" className="label-radio">
                                        Current Year
                                    </Form.Check.Label>
                                </div>
                            </div>
                        </div>
                    </div>
                </tr>
                <tr>
                    <td>
                        <table style={{ paddingTop: "16px" }}>
                            <tr>
                                <td style={{ width: "20%", paddingRight: "10px" }}>
                                    {dashboardLoading ? (
                                        <Skeleton skeletonType="PropertyOverviewCard" />
                                    ) : (
                                        <div className="allSettingsBox d-flex justify-content-between">
                                            <div className="allSettingsBoxContent">
                                                <p className="valueForDashboard">
                                                    {dashboardData?.occ_data?.[0]?.RevPAR
                                                        ? commonService.formateAmount(
                                                            Math.round(dashboardData?.occ_data?.[0]?.RevPAR)
                                                        )
                                                        : commonService.formateAmount(0)}
                                                </p>
                                                <div className="footerForCardDashboard">
                                                    <img src={avgOfRevPar} />
                                                    <p className="titleForDashboard">RevPAR</p>
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                </td>
                                <td style={{ width: "20%", paddingRight: "10px" }}>
                                    {dashboardLoading ? (
                                        <Skeleton skeletonType="PropertyOverviewCard" />
                                    ) : (
                                        <div className="allSettingsBox d-flex justify-content-between">
                                            <div className="allSettingsBoxContent">
                                                <p className="valueForDashboard">
                                                    {dashboardData?.occ_data?.[0]?.ADR
                                                        ? commonService.formateAmount(
                                                            Math.round(dashboardData?.occ_data?.[0]?.ADR)
                                                        )
                                                        : commonService.formateAmount(0)}
                                                </p>
                                                <div className="footerForCardDashboard">
                                                    <img src={avgOfAdr} />
                                                    <p className="titleForDashboard">ADR</p>
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                </td>
                                <td style={{ width: "20%", paddingRight: "10px" }}>
                                    {dashboardLoading ? (
                                        <Skeleton skeletonType="PropertyOverviewCard" />
                                    ) : (
                                        <div className="allSettingsBox d-flex justify-content-between">
                                            <div className="allSettingsBoxContent">
                                                <p className="valueForDashboard">
                                                    {dashboardData?.occ_data?.[0]?.TotalRevenue
                                                        ? commonService.formateAmount(
                                                            Math.round(
                                                                dashboardData?.occ_data?.[0]?.TotalRevenue
                                                            )
                                                        )
                                                        : commonService.formateAmount(0)}
                                                </p>
                                                <div className="footerForCardDashboard">
                                                    <img src={sumOfTotalRev} />
                                                    <p className="titleForDashboard">Revenue</p>
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                </td>
                                <td style={{ width: "20%", paddingRight: "10px" }}>
                                    {dashboardLoading ? (
                                        <Skeleton skeletonType="PropertyOverviewCard" />
                                    ) : (
                                        <div className="allSettingsBox d-flex justify-content-between">
                                            <div className="allSettingsBoxContent">
                                                <p className="valueForDashboard">
                                                    {dashboardData?.overallcompavg?.[0]?.avgcompRate
                                                        ? commonService.formateAmount(
                                                            Math.round(
                                                                dashboardData?.overallcompavg?.[0]?.avgcompRate
                                                            )
                                                        )
                                                        : commonService.formateAmount(0)}
                                                </p>
                                                <div className="footerForCardDashboard">
                                                    <img src={overallCompAvg} />
                                                    <p className="titleForDashboard">Comp Avg</p>
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                </td>
                                <td style={{ width: "20%" }}>
                                    {dashboardLoading ? (
                                        <Skeleton skeletonType="PropertyOverviewCard" />
                                    ) : (
                                        <div className="allSettingsBox d-flex justify-content-between">
                                            <div
                                                className="allSettingsBoxContent"
                                                style={{ width: "100%" }}
                                            >
                                                <div className="d-flex justify-content-between align-items-center">
                                                    <div className="d-flex align-items-baseline gap-2">
                                                        <p className="valueForDashboard">
                                                            {dashboardData?.res_data?.[0]
                                                                ?.CancellationPercentage
                                                                ? dashboardData?.res_data?.[0]
                                                                    ?.CancellationPercentage
                                                                : 0}
                                                            %
                                                        </p>
                                                        <p className="revLossForDashboard">
                                                            {dashboardData?.res_data?.[0]?.RevenueLoss
                                                                ? `(${commonService.formateAmount(
                                                                    dashboardData?.res_data?.[0]?.RevenueLoss
                                                                )})`
                                                                : `(${commonService.formateAmount(0)})`}
                                                        </p>
                                                    </div>
                                                    <img id={commonService.generateGlobalClickTrackerID("PropertyOverview", "viewicon", propertyCode)}
                                                        src={viewIcon}
                                                        className="cursorPointer"
                                                        onClick={(e) => {
                                                            if (clickedEyeIcon.current) {
                                                                closeGroupDate();
                                                            } else {
                                                                clickedEyeIcon.current = true;
                                                                handleGroupBtnClick(e);
                                                            }
                                                        }}
                                                    />
                                                </div>
                                                <div className="footerForCardDashboard">
                                                    <img src={cancellationPercentage} />
                                                    <p className="titleForDashboard">
                                                        Cancellation (Rev Loss)
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                </td>
                            </tr>
                        </table>
                    </td>
                </tr>
                <tr>
                    <td>
                        <table style={{ paddingTop: "16px" }}>
                            <tr>
                                <td style={{ width: "66.66666667%" }}>
                                    <table style={{ marginTop: "5px" }}>
                                        <tr>
                                            <td
                                                style={{
                                                    width: "25%",
                                                    verticalAlign: "top",
                                                    paddingRight: "10px",
                                                }}
                                            >
                                                {dashboardLoading ? (
                                                    <Skeleton skeletonType="PropertyOverviewCard" />
                                                ) : (
                                                    <div className="allSettingsBox d-flex justify-content-between">
                                                        <div className="allSettingsBoxContent">
                                                            <div className="d-flex align-items-baseline gap-2">
                                                                <p className="valueForDashboard">
                                                                    {dashboardData?.res_data?.[0]?.avgLeadTime
                                                                        ? dashboardData?.res_data?.[0]?.avgLeadTime
                                                                        : 0}
                                                                </p>
                                                                <p className="subValueForDashboard">Days</p>
                                                            </div>
                                                            <div className="footerForCardDashboard">
                                                                <img src={avgOfLeadTime} />
                                                                <p className="titleForDashboard">Lead Time</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                )}
                                            </td>
                                            <td
                                                style={{
                                                    width: "25%",
                                                    verticalAlign: "top",
                                                    paddingRight: "10px",
                                                }}
                                            >
                                                {dashboardLoading ? (
                                                    <Skeleton skeletonType="PropertyOverviewCard" />
                                                ) : (
                                                    <div className="allSettingsBox d-flex justify-content-between">
                                                        <div className="allSettingsBoxContent">
                                                            <div className="d-flex align-items-baseline gap-2">
                                                                <p className="valueForDashboard">
                                                                    {dashboardData?.res_data?.[0]?.avgLOS
                                                                        ? dashboardData?.res_data?.[0]?.avgLOS
                                                                        : 0}
                                                                </p>
                                                                <p className="subValueForDashboard">Days</p>
                                                            </div>
                                                            <div className="footerForCardDashboard">
                                                                <img src={avgOfLengthOfStay} />
                                                                <p className="titleForDashboard">LOS</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                )}
                                            </td>
                                            <td
                                                style={{
                                                    width: "25%",
                                                    verticalAlign: "top",
                                                    paddingRight: "10px",
                                                }}
                                            >
                                                {dashboardLoading ? (
                                                    <Skeleton skeletonType="PropertyOverviewCard" />
                                                ) : (
                                                    <div className="allSettingsBox d-flex justify-content-between">
                                                        <div className="allSettingsBoxContent">
                                                            <div className="d-flex align-items-baseline gap-2">
                                                                <p className="valueForDashboard">
                                                                    {dashboardData?.occ_data?.[0]?.Inventory
                                                                        ? dashboardData?.occ_data?.[0]?.Inventory
                                                                        : 0}
                                                                </p>
                                                                <p className="subValueForDashboard">
                                                                    {dashboardData?.occ_data?.[0]?.RoomsOfAvailable
                                                                        ? `(${dashboardData?.occ_data?.[0]?.RoomsOfAvailable})`
                                                                        : `(0)`}
                                                                </p>
                                                            </div>
                                                            <div className="footerForCardDashboard">
                                                                <img src={totalInventory} />
                                                                <p className="titleForDashboard">Inventory</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                )}
                                            </td>
                                            <td
                                                style={{
                                                    width: "25%",
                                                    verticalAlign: "top",
                                                    paddingRight: "10px",
                                                }}
                                            >
                                                {dashboardLoading ? (
                                                    <Skeleton skeletonType="PropertyOverviewCard" />
                                                ) : (
                                                    <div className="allSettingsBox d-flex justify-content-between">
                                                        <div className="allSettingsBoxContent">
                                                            <div className="d-flex align-items-baseline gap-2">
                                                                <p className="valueForDashboard">
                                                                    {dashboardData?.occ_data?.[0]?.RoomSold
                                                                        ? dashboardData?.occ_data?.[0]?.RoomSold
                                                                        : 0}
                                                                </p>
                                                                <p className="subValueForDashboard">
                                                                    {dashboardData?.occ_data?.[0]?.OCC
                                                                        ? `(${dashboardData?.occ_data?.[0]?.OCC}%)`
                                                                        : `(0%)`}
                                                                </p>
                                                            </div>
                                                            <div className="footerForCardDashboard">
                                                                <img src={avgOfRoomSold} />
                                                                <p className="titleForDashboard">
                                                                    Room Sold (Occ%)
                                                                </p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                )}
                                            </td>
                                        </tr>
                                    </table>
                                    <table style={{ marginTop: "10px" }}>
                                        <tr>
                                            <td
                                                style={{
                                                    width: "33%",
                                                    verticalAlign: "top",
                                                    paddingRight: "10px",
                                                }}
                                            >
                                                {dashboardLoading ? (
                                                    <Skeleton skeletonType="PropertyOverviewCard" />
                                                ) : (
                                                    <div className="allSettingsBox d-flex justify-content-between">
                                                        <div className="allSettingsBoxContent">
                                                            <p className="valueForDashboard">
                                                                {dashboardData?.occ_data?.[0]?.AvailableOccupancy
                                                                    ? dashboardData?.occ_data?.[0]
                                                                        ?.AvailableOccupancy
                                                                    : 0}
                                                            </p>
                                                            <div className="footerForCardDashboard">
                                                                <img src={avgOfRoomAvailable} />
                                                                <p className="titleForDashboard">Left to Sell</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                )}
                                            </td>
                                            <td
                                                style={{
                                                    width: "33%",
                                                    verticalAlign: "top",
                                                    paddingRight: "10px",
                                                }}
                                            >
                                                <div>
                                                    <div className="ViewPropertySetupTable">
                                                        <div className="stripped__table">
                                                            <div className="table-responsive tblTopMsSticky">
                                                                <Table
                                                                    id={tblids.id1}
                                                                    className="table-with-spacing positionStaticTable dailySummaryTbl"
                                                                >
                                                                    <thead className="tbl-header-sticky">
                                                                        <tr className="table-main-header-tr">
                                                                            <th className="text-center" colSpan={4}>
                                                                                Pickup
                                                                            </th>
                                                                        </tr>
                                                                        <tr className="table-main-header-tr">
                                                                            <th className="text-center"></th>
                                                                            <th className="text-end">1 Day</th>
                                                                            <th className="text-end">7 Day</th>
                                                                            <th className="text-end">14 Day</th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        <tr>
                                                                            <td className="fw-bold">OCC</td>
                                                                            <td className="text-end">
                                                                                {
                                                                                    dashboardData?.occ_data?.[0]
                                                                                        ?.Pickup1RoomSold
                                                                                }
                                                                            </td>
                                                                            <td className="text-end">
                                                                                {
                                                                                    dashboardData?.occ_data?.[0]
                                                                                        ?.Pickup7RoomSold
                                                                                }
                                                                            </td>
                                                                            <td className="text-end">
                                                                                {
                                                                                    dashboardData?.occ_data?.[0]
                                                                                        ?.Pickup14RoomSold
                                                                                }
                                                                            </td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td className="fw-bold">ADR</td>
                                                                            <td className="text-end">
                                                                                {commonService.formateAmount(
                                                                                    dashboardData?.occ_data?.[0]
                                                                                        ?.Pickup1ADR
                                                                                )}
                                                                            </td>
                                                                            <td className="text-end">
                                                                                {commonService.formateAmount(
                                                                                    dashboardData?.occ_data?.[0]
                                                                                        ?.Pickup7ADR
                                                                                )}
                                                                            </td>
                                                                            <td className="text-end">
                                                                                {commonService.formateAmount(
                                                                                    dashboardData?.occ_data?.[0]
                                                                                        ?.Pickup14ADR
                                                                                )}
                                                                            </td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td className="fw-bold">REV</td>
                                                                            <td className="text-end">
                                                                                {commonService.formateAmount(
                                                                                    dashboardData?.occ_data?.[0]
                                                                                        ?.Pickup1TotalRevenue
                                                                                )}
                                                                            </td>
                                                                            <td className="text-end">
                                                                                {commonService.formateAmount(
                                                                                    dashboardData?.occ_data?.[0]
                                                                                        ?.Pickup7TotalRevenue
                                                                                )}
                                                                            </td>
                                                                            <td className="text-end">
                                                                                {commonService.formateAmount(
                                                                                    dashboardData?.occ_data?.[0]
                                                                                        ?.Pickup14TotalRevenue
                                                                                )}
                                                                            </td>
                                                                        </tr>
                                                                    </tbody>
                                                                </Table>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </td>
                                            <td
                                                style={{
                                                    width: "33%",
                                                    verticalAlign: "top",
                                                    paddingRight: "10px",
                                                }}
                                            >
                                                <div>
                                                    <div className="ViewPropertySetupTable">
                                                        <div className="stripped__table">
                                                            <div className="table-responsive tblTopMsSticky">
                                                                <Table
                                                                    id={tblids.id2}
                                                                    className="table-with-spacing positionStaticTable dailySummaryTbl"
                                                                >
                                                                    <thead className="tbl-header-sticky">
                                                                        <tr className="table-main-header-tr">
                                                                            <th className="text-center" colSpan={4}>
                                                                                Forecast
                                                                            </th>
                                                                        </tr>
                                                                        <tr className="table-main-header-tr">
                                                                            <th className="text-center"></th>
                                                                            <th className="text-end">RM Copilot</th>
                                                                            <th className="text-end">User</th>
                                                                            <th className="text-end">System</th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        <tr>
                                                                            <td className="fw-bold">OCC</td>
                                                                            <td className="text-end">
                                                                                {
                                                                                    dashboardData?.occ_data?.[0]
                                                                                        ?.NOVA_Forecast_RoomSold
                                                                                }
                                                                            </td>
                                                                            <td className="text-end">
                                                                                {
                                                                                    dashboardData?.occ_data?.[0]
                                                                                        ?.USER_Forecast_RoomSold
                                                                                }
                                                                            </td>
                                                                            <td className="text-end">
                                                                                {
                                                                                    dashboardData?.occ_data?.[0]
                                                                                        ?.Forecast_RoomSold
                                                                                }
                                                                            </td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td className="fw-bold">ADR</td>
                                                                            <td className="text-end">
                                                                                {commonService.formateAmount(
                                                                                    dashboardData?.occ_data?.[0]
                                                                                        ?.NOVA_Forecast_ADR
                                                                                )}
                                                                            </td>
                                                                            <td className="text-end">
                                                                                {commonService.formateAmount(
                                                                                    dashboardData?.occ_data?.[0]
                                                                                        ?.USER_Forecast_ADR
                                                                                )}
                                                                            </td>
                                                                            <td className="text-end">
                                                                                {commonService.formateAmount(
                                                                                    dashboardData?.occ_data?.[0]
                                                                                        ?.Forecast_ADR
                                                                                )}
                                                                            </td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td className="fw-bold">REV</td>
                                                                            <td className="text-end">
                                                                                {commonService.formateAmount(
                                                                                    dashboardData?.occ_data?.[0]
                                                                                        ?.NOVA_Forecast_Revenue
                                                                                )}
                                                                            </td>
                                                                            <td className="text-end">
                                                                                {commonService.formateAmount(
                                                                                    dashboardData?.occ_data?.[0]
                                                                                        ?.USER_Forecast_Revenue
                                                                                )}
                                                                            </td>
                                                                            <td className="text-end">
                                                                                {commonService.formateAmount(
                                                                                    dashboardData?.occ_data?.[0]
                                                                                        ?.Forecast_Revenue
                                                                                )}
                                                                            </td>
                                                                        </tr>
                                                                    </tbody>
                                                                </Table>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </td>
                                        </tr>
                                    </table>
                                </td>
                                <td
                                    style={{
                                        width: "33.33333333%",
                                        verticalAlign: "top",
                                        paddingTop: "7px",
                                    }}
                                >
                                    <div className="ViewPropertySetupTable">
                                        <div className="stripped__table">
                                            <div className="table-responsive tblTopMsSticky">
                                                <Table
                                                    id={tblids.id3}
                                                    className="table-with-spacing positionStaticTable dailySummaryTbl"
                                                >
                                                    <thead className="tbl-header-sticky">
                                                        <tr className="table-main-header-tr">
                                                            <th className="text-center" colSpan={4}>
                                                                Top Market Segment
                                                            </th>
                                                        </tr>
                                                        <tr className="table-main-header-tr">
                                                            <th className="border_right">Rate Code</th>
                                                            <th className="border_right text-center">
                                                                Rooms
                                                            </th>
                                                            <th className="border_right text-end">Revenue</th>
                                                            <th className="text-end">ADR</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {marketSegmentLoading ? (
                                                            <tr
                                                                style={{ height: "80px", position: "relative" }}
                                                            >
                                                                <Loader />
                                                            </tr>
                                                        ) : marketSegmentData?.length > 0 ? (
                                                            marketSegmentData?.map((item) => {
                                                                return (
                                                                    <ExpandableRows
                                                                        item={item}
                                                                        level={0}
                                                                        toggleRows={toggleRows}
                                                                        expandedRows={expandedRows}
                                                                        ratecodeApi={getRatecodeDrilldown}
                                                                        setApiLoading={setApiLoading}
                                                                        apiLoading={apiLoading}
                                                                        calledMs={calledMarketSegmentRef.current}
                                                                    />
                                                                );
                                                            })
                                                        ) : (
                                                            <tr className="text-center">
                                                                <td colSpan={4}>No Data Found</td>
                                                            </tr>
                                                        )}
                                                    </tbody>
                                                </Table>
                                            </div>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </table>
                    </td>
                </tr>
            </table>
            {api !== 0 && (
                <Comments widgetDetails={para} editorId={"PropertyOverview"} />
            )}
            {widgetModal && (
                <WidgetDetailModal
                    showModal={widgetModal}
                    closeModal={closeWidgetModal}
                    data={widgetDetailRef.current}
                />
            )}
        </div>
    );
};

export default PropertyOverview;
